import { VideoPrivacy } from '@vimeo/clip-ui/constants';
import { AnalyticsPropsType } from '@vimeo/comments-view';
import { GetAlbumVideosFields, GetAlbumVideosOptions } from '@vimeo/gctl-api/fetchers/album/videos';
import { Album } from '@vimeo/gctl-api/models/components/schemas/album/Album';

export type AlbumSortKey =
  | 'alphabetical'
  | 'newest'
  | 'oldest'
  | 'likes'
  | 'plays'
  | 'comments'
  | 'arranged'
  | 'added_first'
  | 'added_last'
  | 'modified_time_desc'
  | 'modified_time_asc';

export type AlbumSortConfig = {
  sort: NonNullable<GetAlbumVideosOptions<GetAlbumVideosFields>['query']>['sort'];
  direction?: NonNullable<GetAlbumVideosOptions<GetAlbumVideosFields>['query']>['direction'];
};

export const COMMENTS_ANALYTICS_PROPS: AnalyticsPropsType = {
  productContextFields: {
    product: 'showcase',
  },
  webContextFields: {
    page_name: 'showcase_recipient',
  },
};

export interface CommentsModuleProps {
  clipOwnerUri?: string;
  clipRequestId: string;
  clipId: string;
  privacyView?: VideoPrivacy;
  showComments: boolean;
}

export interface VideoActionBarModuleProps {
  canInteract: boolean;
  clipRequestId: string;
  clipId: string;
  showComments: boolean;
  showDownload: boolean;
  showShare: boolean;
  showLike: boolean;
  canLike: boolean;
  isVideoProcessing: boolean;
}

export type BpCollectionPrivacy =
  | 'anybody'
  | 'disable'
  | 'nobody'
  | 'password'
  | 'unlisted'
  | 'team'
  | null;

export interface BpCollectionContextsType {
  entity_id: number;
  number_of_videos?: number | null;
  is_seo_on?: boolean | null;
  collection_privacy?: Album['privacy']['view'] | null;
}

export interface VideoShareModalSharedType {
  hideTimestampCheckbox?: boolean;
  albumId?: number | null;
  clipId?: string | null;
  type?: 'video' | 'albumVideo';
}
export interface LiveChatStatusResponse {
  chatEnabled: boolean;
  roomId: number;
}
